import PlatformCardSkeleton from "@/app/[locale]/(platform)/sharedComponents/platformCardSkeleton";
import { View } from "../../types";
import PlatformListItemSkeleton from "@/app/[locale]/(platform)/sharedComponents/platformListItemSkeleton";

export default function FileCardSkeleton({ view }: { view: View }) {
    if (view === "grid") {
        return <PlatformCardSkeleton title subtitle thumbnail />;
    }

    return <PlatformListItemSkeleton title subtitle thumbnail />;
}
